module.exports = __webpack_public_path__ + "static/eu4b-logo-1c590d0958b028ae5abf94eb2b80ba41.png";